// @ts-strict-ignore
import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from "@angular/core";
import {Router} from "@angular/router";
import {CameraLayoutOptionsContainer} from "@models";
import {BaseRecorderLayout} from "../base-recorder-layout";

@Component({
	selector: "sim-recorder-layout-twin",
	templateUrl: "./recorder-layout-twin.component.html",
	styleUrls: ["./recorder-layout-twin.component.scss"],
	standalone: false,
})
export class RecorderLayoutTwinComponent extends BaseRecorderLayout implements OnInit, OnChanges, OnDestroy {
	@Input() cameraLayoutOptionsContainer: CameraLayoutOptionsContainer;

	public twinViewHeader: JQuery = null;
	public twinViewBody: JQuery = null;
	public twinViewFooter: JQuery = null;
	public twinViewBodyHeight = 0;

	public stackedVertically = false;
	public cameraClasses = "col-xs-6 col-md-6 col-lg-6";

	constructor(private _router: Router) {
		super();
	}

	ngOnInit() {
		const url = this._router.url;
		this.stackedVertically =
			this.isActive(url, "training-room-viewer") || this.isActive(url, "web-participant-viewing-station-advanced");

		// In the training room viewer we want the cameras stacked
		// vertically.
		if (this.stackedVertically) {
			this.cameraClasses = "col-xs-12 col-md-12 col-lg-12";
		} else {
			this.cameraClasses = "col-xs-6 col-md-6 col-lg-6";

			// Attach resize handler
			this.twinViewBody = $("#twin-view-body");
			this.twinViewHeader = $("#twin-view-header");
			this.twinViewFooter = $("#twin-view-footer");
		}
	}

	private isActive(current_rul: string, url: string) {
		return current_rul.includes(url);
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.updateLayout();
	}

	ngOnDestroy(): void {}

	private updateLayout() {
		// 2019-03-28, Alex
		// Null-Checks added
		if (this.twinViewBody && this.twinViewBody.length > 0) {
			const bodyHeight = this.twinViewBody.outerHeight();

			if (this.twinViewHeader && this.twinViewHeader.length > 0) {
				this.twinViewHeader.height(bodyHeight / 2);
			}

			if (this.twinViewFooter && this.twinViewFooter.length > 0) {
				this.twinViewFooter.height(bodyHeight / 2);
			}
		}
	}
}
